import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Container, Button, Col, Row } from 'reactstrap';
import { toast } from 'react-toastify';
import { Link, useHistory } from 'react-router-dom';
import { toggleResetPassModal } from '../actions/Profile';
import {
  postReleaseNote,
  getReleaseNotes,
  getMaintenanceNotes,
  updateReleaseNotes,
  deleteReleaseNotes,
} from '../actions/EpikBoxes';
import UpdateUserPasswordModal from './UpdateUserPasswordModal';
import CustomModal from './CustomModal';
import './UserProfile.css';
import ReleaseNote from './ReleaseNote';
import ReleaseDisplayNotes from './ReleaseDisplayNotes';
import ActiveMaintenance from './ActiveMaintenance';
import { addSystemLogs } from '../actions/SystemLogs';
import TwoFactorSetup from './TwoFactorSetup';
import utils from '../lib/utils';
import { useUnifiedFetch, useUnifiedMutate } from '../hooks';
import Spinner from './Spinner/Spinner'
import ProfileSettings from './ProfileSettings';
import { ReactComponent as EpikHelpIcon } from '../Res/Epik_Help_icon.svg';
import TooltipCustom from './EpikBoxes/EpikBoxDetails/TooltipCustom';
import * as UserActions from '../actions/User';
import { getPermissionForComponent } from '../utils/permissionsUtils';
import { COMPANY_TYPE_DROPDOWN } from '../lib/constants';



const default2FaOptions = { '2factorapp': "Authentication App", sms: 'SMS', email: 'Email'  }


const UserProfile = ({
  profile,
  openModal,
  toggleResetPassModal,
  resetPassword,
  user,
  postReleaseNote,
  getReleaseNotes,
  getMaintenanceNotes,
  toggleIframe,
  updateReleaseNotes,
  deleteReleaseNotes,
  addSystemLogs,
  getUserData,
}) => {
  const { name, email, phoneNumber, registerDate, company } = profile;
  const [openReleaseModal, setOpenReleaseModal] = useState(false);
  const [openReleaseDisplayModal, setOpenReleaseDisplayModal] = useState(false);
  const [releaseDisplayArr, setReleaseDisplayArr] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [isActiveMaintenanceModalOpen, setisActiveMaintenanceModalOpen] = useState(false);
  const [activeMaintenanceNotes, setactiveMaintenanceNotes] = useState([]);
  const [editReleaseHtml, setEditReleaseHtml] = useState('');

  const [twoFactorModal, setTwoFactorModal] = useState(false);
  const [profileSettings, setProfileSettings] = useState(false);

  const token = localStorage.getItem('jwtToken');
  const history = useHistory();

  const docToolAccess = getPermissionForComponent('docToolAccess', user.permissionsGroup);

  const {
    isLoading: isFetchingProfileSettings,
    data: userProfileSettings,
    fetchData: fetchUserProfileSettings,
  } = useUnifiedFetch(`users/profile-settings/${user?._id}`, false, true);

  const { mutate: userProfileSettingsMutate, isLoading: isUserProfileSettingsMutating } = useUnifiedMutate();
 

  const ProfileItem = ({ title, data }) => (
    <div className="profile-info-item">
      <p className="profile-info-title">{title}</p>
      <span className="profile-info-data">{data || `${title} is not specified`}</span>
    </div>
  );

  useMemo(async () => {
    if (resetPassword) {
      toggleResetPassModal(true);
    }
  }, []);

  useEffect(() => {
    fetchUserProfileSettings();
  }, [user?._id])

  const onReleaseDisplay = async () => {
    const displayReleaseArray = await getReleaseNotes(token);
    setReleaseDisplayArr(displayReleaseArray);
    setOpenReleaseDisplayModal(true);
  };

  const onDeleteReleaseNote = async (noteID) => {
    try {
      // Call  deleteReleaseNotes action or API function
      await deleteReleaseNotes(token, noteID);
      // If deletion is successful, update the releaseDisplayArr
      const updatedReleaseArray = await getReleaseNotes(token);
      setReleaseDisplayArr(updatedReleaseArray);
    } catch (error) {
      console.error('Error deleting release note:', error);
      // Handle error if deletion fails
    }
  };
  const onActiveMaintenanceDisplay = async () => {
    const maintenanceNotes = await getMaintenanceNotes(token);
    setactiveMaintenanceNotes(maintenanceNotes);
    setisActiveMaintenanceModalOpen(true);
  };

  const onformValues = values => {
    setFormValues(values);
  };

  const flattenObject = obj => {
    const flattened = {};

    Object.keys(obj).forEach(key => {
      const value = obj[key];

      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        if (Object.keys(value).length === 0) flattened[key] = value;
        Object.assign(flattened, flattenObject(value));
      } else {
        flattened[key] = value;
      }
    });

    return flattened;
  };

  const onTwoFactorSetup = () => {
    setTwoFactorModal(!twoFactorModal)
  }

  const onProfileSettings = async (e) => {
    const profileSettingsEndPoint = `users/profile-settings/${user?._id}`;
    let method = 'PUT';

    const profileSettingsBody = {
        timeZone: e?.timeZone?.value || 'browser',
        default2fa: e?.default2Fa
    }

    const profileSettingsProfile = await userProfileSettingsMutate({ isMyEpik: true, endpoint: profileSettingsEndPoint, method, body: profileSettingsBody })

    if(profileSettingsProfile && !isUserProfileSettingsMutating){
      fetchUserProfileSettings();
      setProfileSettings(false);
      getUserData(token)
    }
  }

  const onReleasePublish = async () => {
    if (formValues.frequency === 'One Time' && formValues.type === 'Maintenance Notification')
      delete formValues.recFrequency;

    const isNotEmpty = Object.values(flattenObject(formValues)).every(x => x.length > 0);

    if (isNotEmpty) {
      if (formValues.type === 'Release Notes') {
        const titleHtml = `<p><strong>${formValues.title}</strong></p>\n`;
        const htmlText = titleHtml + formValues.htmlText;
        formValues.htmlText = htmlText;
      }
      const res = await postReleaseNote(token, formValues);
      if (res) {
        setOpenReleaseModal(false);
        setEditReleaseHtml('');
        const body = {
          actionType: 'system',
          description: `${formValues.type} has been added`,
        };
        await addSystemLogs(token, body);
      }
    } else {
      toast.error('Please fill all the fields.');
    }
  };

  const onUpdatePublish = async () => {
    delete formValues.frequency;
    const newFormData = {
      frequency: 'One Time',
      htmlText: formValues.htmlText,
      type: formValues.type,
      title: formValues.title,
      publishDate: formValues.publishDate,
      publishTime: formValues.publishTime,
      _id: formValues._id,
    };
    const isNotEmpty = Object.values(flattenObject(newFormData)).every(x => x.length > 0);

    if (isNotEmpty) {
      if (newFormData.type === 'Release Notes') {
        const titleHtml = `<p><strong>${newFormData.title}</strong></p>\n`;
        const htmlText = titleHtml + newFormData.htmlText;
        newFormData.htmlText = htmlText;
      }
      const res = await updateReleaseNotes(token, newFormData);
      if (res) {
        setOpenReleaseModal(false);
        setEditReleaseHtml('');
        const body = {
          actionType: 'system',
          description: `${newFormData.type} has been added`,
        };
        await addSystemLogs(token, body);
      }
    } else {
      toast.error('Please fill all the fields.');
    }
  };

  const closeMaintenanceModal = value => {
    setisActiveMaintenanceModalOpen(value);
  };

  const onMonitoringDashboard = () => {
    history.push('/dashboard-monitor');
  };

  const latestEdit = data => {
    const newHtml = {
      htmlText: data,
    };
    setEditReleaseHtml(newHtml);
  };

  useEffect(() => {
    if (editReleaseHtml) {
      setOpenReleaseModal(true);
    }
  }, [editReleaseHtml]);

  const renderTimeZone = (userTimezone) => {
    if(userTimezone === 'browser' || !userTimezone) {
      return <ProfileItem title="User Time Zone"  data={  Intl.DateTimeFormat().resolvedOptions().timeZone} />
    } else if(userTimezone){
      return <ProfileItem title="User Time Zone"  data={ userTimezone } />
    }
  }

  const renderDefault2fa = (default2Fa) => {
    if(default2Fa) {
      return <ProfileItem title="Default 2FA Method"  data={ default2FaOptions[default2Fa] }/>
    }
    return <ProfileItem title="Default 2FA Method"  data={'Email'} />
  }

  return (
    <>
    <Container className="profileContainer" style={{ padding: '1rem' }}>
      <Row>
        <Col md={12}>
          <div className="profile-info-container text-left">
            <div  className='profile-info-header'>
              <h5 className='profile-info-header-title'>Profile Details</h5>
              <Button
                onClick={() => setProfileSettings(true)}
                color="primary"
              >
                Edit Profile
              </Button>
            </div>
            <hr className="profile-info-line" />
            <ProfileItem title="Full Name" data={name} />
            <ProfileItem title="Email" data={email} />
            <ProfileItem title="Contact Phone" data={phoneNumber} />
            <ProfileItem
              title="Company"
              data={company ? `${company.name} (Type: ${COMPANY_TYPE_DROPDOWN.find(el => el.value === company.companyType)?.label})` : ''}
            />
            <ProfileItem title="Created On" data={utils.getDateTimeFormat(registerDate, 'regular')} />
            { renderTimeZone(userProfileSettings?.timeZone) } 
            { renderDefault2fa(userProfileSettings?.default2fa) } 
          </div>
        </Col>
      </Row>
    </Container>
    <Container className="profileContainer" style={{ padding: '1rem', marginTop: 20 }}>
      <Row>
        <Col>
        <Row>
            <Col md={3} className="d-flex flex-column align-items-start">
              <Button color="link" onClick={onReleaseDisplay}>
                Release Notes
              </Button>
              {
                (user.role != 'admin' &&
                  user.role != 'enterpriseAdmin'  && user.role != 'user') && 
                  <Button color="link" onClick={() => setOpenReleaseModal(true)}>
                    Post a Release Note
                </Button>
              }
            </Col>
              {user.role === 'superAdmin' && (
                <Col md={4} className="d-flex flex-column align-items-start">
                  <Button color="link" onClick={onActiveMaintenanceDisplay}>
                    Active Maintenance Notifications
                  </Button>
                </Col>
              )}
              <Col md={4} className="d-flex flex-column align-items-start">
                {user.twoFactor && <Button color="link" onClick={() => setTwoFactorModal(true)}>
                  Setup-2-Factor-Authentication
                </Button>}
                <Button color="link" onClick={() => toggleResetPassModal(true)}>
                  Reset password
                </Button>
              </Col>
      </Row>
        </Col>
          {/* {docToolAccess &&
                <Col md={1} className="d-flex flex-column align-items-end epik-help">
                  <TooltipCustom
                    tipId="help_icon"
                    displayData="EPIK Documentation and Guides"
                    placement="top"
                  />
                  <EpikHelpIcon id='help_icon' width={34} height={34} onClick={() => toggleIframe(true)} className='epik-icon-help' />
                </Col>
              } */}
      </Row>

    </Container>
      {openModal && (
        <UpdateUserPasswordModal
          resetPassword={resetPassword}
          isOpen={openModal}
          onCancel={() => toggleResetPassModal(false)}
        />
      )}
      <CustomModal
        header="Release Note"
        confirmBtnText={editReleaseHtml ? 'Update' : 'Submit'}
        isOpen={openReleaseModal}
        onCancel={() => {
          setOpenReleaseModal(false);
          setEditReleaseHtml('');
        }}
        onConfirm={editReleaseHtml ? onUpdatePublish : onReleasePublish}
        wider
      >
        <ReleaseNote
          currentState={editReleaseHtml?.htmlText}
          edit
          releaseFormValues={onformValues}
        />
      </CustomModal>
      <CustomModal
        header="Release Note"
        isOpen={openReleaseDisplayModal}
        onCancel={() => setOpenReleaseDisplayModal(false)}
        submitDisplay
      >
      <ReleaseDisplayNotes 
          releaseDisplayArr={releaseDisplayArr} 
          latestEdit={latestEdit}  
          onDeleteReleaseNote={onDeleteReleaseNote} // Pass the callback function
      />
      </CustomModal>
      <CustomModal
        header="Active Maintenance Notifications"
        isOpen={isActiveMaintenanceModalOpen}
        onCancel={() => setisActiveMaintenanceModalOpen(false)}
        submitDisplay
        close
        medium
      >
        <ActiveMaintenance
          notes={activeMaintenanceNotes}
          updateReleaseNotes={updateReleaseNotes}
          closeMaintenanceModal={closeMaintenanceModal}
          deleteReleaseNotes={deleteReleaseNotes}
        />
      </CustomModal>
      {twoFactorModal && <TwoFactorSetup isOpen={twoFactorModal} toggleModal={onTwoFactorSetup} />}
      {profileSettings && <ProfileSettings 
                            isOpen={profileSettings} 
                            handleCancel={() => setProfileSettings(false)}
                            isUserProfileSettingsMutating={isUserProfileSettingsMutating}
                            saveProfileSettings={onProfileSettings} 
                            userTimezone={userProfileSettings?.timeZone}
                            default2FaMethod={userProfileSettings?.default2fa}                          
                          />}
    </>
  );
};

const mapStateToProps = state => ({
  openModal: state.UIState.profile.openResetPassModal,
  user: state.AppState.user,
});

const mapDispatchToProps = dispatch => ({
  toggleResetPassModal: isOpen => dispatch(toggleResetPassModal(isOpen)),
  postReleaseNote: (token, note) => dispatch(postReleaseNote(token, note)),
  updateReleaseNotes: (token, note) => dispatch(updateReleaseNotes(token, note)),
  getReleaseNotes: token => dispatch(getReleaseNotes(token)),
  getMaintenanceNotes: token => dispatch(getMaintenanceNotes(token)),
  deleteReleaseNotes: (token, noteID) => dispatch(deleteReleaseNotes(token, noteID)),
  addSystemLogs: (token, body) => dispatch(addSystemLogs(token, body)),
  getUserData: token => dispatch(UserActions.getUserData(token)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserProfile);
